module.exports = "<app-header></app-header>\n\n<div class=\"wrapper\">\n  <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>"